import React from "react";
import { WebMercatorViewport } from "@deck.gl/core";
import { FlyToInterpolator } from "deck.gl";
import { image } from "d3";
import MultipleImages from "../components/MultipleImages";

const transitionLength = 3000;

const customBounds = [43.18668, 36.35634, 43.18668, 36.35634];

const interpolator = new FlyToInterpolator();

const viewport = new WebMercatorViewport({
  width: window.innerWidth,
  height: window.innerHeight,
  longitude: -122.45,
  latitude: 37.78,
  zoom: 12,
  pitch: 0,
  bearing: 0,
});

export const addTransitionsToSlides = (slides) => {
  const transitionsSlides = {};
  Object.keys(slides).forEach((slideNum) => {
    const slide = slides[slideNum];
    // const slideViewState = slide.viewState;
    const { longitude, latitude, zoom } = viewport.fitBounds([
      [slide.bounds[0], slide.bounds[1]],
      [slide.bounds[2], slide.bounds[3]],
    ]);
    const updatedSlide = {
      ...slide,
      viewState: {
        // ...slideViewState,
        longitude,
        latitude,
        zoom,
        transitionDuration: transitionLength,
        transitionInterpolator: interpolator,
        bearing: 0,
        pitch: 0,
      },
    };
    transitionsSlides[slideNum] = updatedSlide;
  });
  return transitionsSlides;
};


const processURL = (localURL) => {
  return localURL.replaceAll(" ", "%20");
};


export const processData = (Data) => {
  //console.log("Data starting: ", Data);
  const data = {};
  
  // PROCESS SLIDES

  const cleanSlides = (Slides) => {
    const slidesNumsIn = [];
    const cleanSlides = [];
    Slides.forEach((slide) => {
      // check if the cell has a slide number
      if (slide["Slide Number"]) {
        // remove cells with the same slide numbers
        if (!slidesNumsIn.includes(slide["Slide Number"])) {
          cleanSlides.push(slide);
        } else {
          //console.log("TWO SLIDES SAME NUMBER, REMOVED:", slide);
        }
        slidesNumsIn.push(slide["Slide Number"]);
      }
    });
    return cleanSlides;
  };
  const slides = cleanSlides(Data.slides).map((slide, idx) => {
    return {
      index: idx,
      audio : slide ["Audio"],
      screenImage: slide["Screen Image"],
      screenImageTitle: slide["Screen Image Title"],
      compareSlider: slide["Compare Slider"],
      title: slide ["Title"],
      textLong: slide["Text Long"],
      textLongAfter: slide["Text Long After"],
      textImage: slide["Text Image"],
      textTitle: slide["Text Title"],
      map: slide ["Map"],
      bounds: slide["Bounds"]
      ? JSON.parse(slide["Bounds"].replace(/\s/g, ""))
      : customBounds,
      contentCard: slide["Card Content"],
      emptyCard: slide["Card Empty"],
      toggleTitle: slide["Toggle Title"],
      toggleContent: slide["Toggle Content"],
      inSlideLink: slide["In Slide Link"],
      inSlideLinkMap: slide["In Slide Link Map"],
      inSlideAudioPlayer: slide["In Slide Audio Player"],
      inSlideVideoPlayer: slide["In Slide Video Player"],
      inSlideVimeoPlayer: slide["In Slide Vimeo Player"],
      inSlideYoutubePlayer: slide["In slide Youtube Player"],
      fullScreenVideo: slide["Full Screen Video"]
        ? processURL(slide["Full Screen Video"])
        : null,
      scrollVideo: slide ["Scroll Video"],
      imageCaption: slide ["Image Caption"],
      textToggleTitle: slide ["Text Toggle Title"],
      textToggleContent: slide ["Text Toggle Content"],
      textImageEnd: slide ["Text Image End"],
      multipleImages: slide ["Multiple Images"],
      textVideo: slide ["Text Video"],
      textIframe: slide ["Text Iframe"],
      textVideoControls: slide ["Text Video Controls"],
      textYoutube: slide ["Text Youtube"],
      share: slide ["Share"],
      graphicMat: slide ["Graphic Material"],
      iframe: slide ["Iframe"],
    };
  });

  data["slides"] = addTransitionsToSlides(slides);
  //console.log(addTransitionsToSlides(slides));

    // PROCESS FRAMES
    const processFrames = (frames) => {

      const settings = {};
      frames.forEach((s) => {
        // console.log(s);
        const slideNum = parseInt(s["Slide Num"]); // should be -1
        // console.log(slideNum);
        settings[slideNum] = [
          parseInt(s["Start Frame"]),
          parseInt(s["End Frame"]),
        ];
      });
      return settings;
    };
  
    data["frames"] = processFrames(Data.frames);
    //console.log("Data Done: ", data);

  return data;
};